// Resolves the current week and loads its JSON.
// Schema: /data/weekly/<year>-week-<n>.json

import { CURRENT_SEASON } from '../config/season';

export function currentWeek() {
  return CURRENT_SEASON.currentWeek ? { ...CURRENT_SEASON.currentWeek } : null;
}

export async function loadWeek(year, week, fetchImpl = fetch) {
  const url = `/data/weekly/${year}-week-${week}.json`;
  const response = await fetchImpl(url);
  if (!response.ok) return null;

  const text = await response.text();
  if (!text || /^\s*<!doctype html/i.test(text) || /^\s*<html/i.test(text)) return null;

  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}
